<template>
    <form
        method="post"
        @submit.prevent="submit"
        @keydown="clearErrors($event.target.name)"
    >
        <div
            v-show="form.succeeded"
            class="alert alert-success"
            v-text="result"
        ></div>
        <div
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('email') }"
        >
            <input
                v-model="form.email"
                type="email"
                class="form-control"
                :placeholder="trans('lang_message.email')"
                name="email"
                autofocus
            />
            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('email')"
                    class="help-block"
                    v-text="form.errors.get('email')"
                ></span>
            </transition>
        </div>

        <div class="row">
            <div class="col-xs-2"></div>
            <!-- /.col -->
            <div class="col-xs-8">
                <button
                    type="submit"
                    class="btn btn-primary btn-block btn-flat"
                    :disabled="form.errors.any()"
                >
                    <i
                        v-if="form.submitting"
                        class="fa fa-refresh fa-spin"
                    ></i>
                    {{ trans('lang_message.sendpassword') }}
                </button>
            </div>
            <!-- /.col -->
            <div class="col-xs-2"></div>
            <!-- /.col -->
        </div>
    </form>
</template>

<script>
import Form from 'acacha-forms';

export default {
    data: function () {
        return {
            form: new Form({ email: '' }),
            result: '',
        };
    },
    mounted() {
        this.form.clearOnSubmit = true;
    },
    methods: {
        submit() {
            this.form
                .post('/password/email')
                .then((response) => {
                    this.result = response.data.status;
                })
                .catch((error) => {
                    console.log(this.trans('lang_message.sendpassword') + ':' + error);
                });
        },
        clearErrors(name) {
            this.form.errors.clear(name);
            this.form.succeeded = false;
            this.result = '';
        },
    },
};
</script>

<style src="./fade.css"></style>
